import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=6d0c6156&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=6d0c6156&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c6156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0c6156')) {
      api.createRecord('6d0c6156', component.options)
    } else {
      api.reload('6d0c6156', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=6d0c6156&scoped=true", function () {
      api.rerender('6d0c6156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/turnover/components/formBox.vue"
export default component.exports